













import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator';

enum TileValueTypes {
  None,
  O,
  X,
}

@Component
export default class Tile extends Vue {
  @Prop({ default: 0 })
  public x!: number;

  @Prop({ default: 0 })
  public y!: number;

  @Prop({ default: TileValueTypes.None })
  public value!: TileValueTypes;

  @Prop({ default: false })
  public isHighlighted!: boolean;

  @Prop({ default: false })
  public isGameOver: boolean = false;
}

export {
  Tile,
  TileValueTypes,
};
